<template>
    <div class="panel-body">
        <slot></slot>
    </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
.panel-body {
    padding: 1em;
}
</style>